import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/headquarters/Headquarters.vue'),
		meta: {
			title: 'sedi',
			acl: 'section.headquarters'
		}
	},
	{
		path: 'new',
		component: () => import('@/views/headquarters/headquarter/HeadquarterDetail.vue'),
		meta: {
			title: 'new-headquarter',
			acl: 'section.headquarters'
		}
	},
	{
		path: ':hqid/edit',
		component: () => import('@/views/headquarters/headquarter/HeadquarterDetail.vue'),
		props: true,
		meta: {
			title: 'edit-headquarter',
			acl: 'section.headquarters'
		}
	}
];

export default routes;